import { Component, Host, h, Prop } from '@stencil/core';
import type { Entry } from '../../../../types/site';
import { getFacadeUrl } from '../../../../utils/api-utils';

export declare type IconLink = {
  icon: string;
  name: string;
  link: string;
  iconFamily: string;
  iconPath?: string;
  iconFillColor?: string;
  iconStrokeColor?: string;
};

@Component({
  tag: 'sy-site-sidebar-link-grid',
  styleUrl: 'sy-site-sidebar-link-grid.scss',
  assetsDirs: ['assets'],
  shadow: true,
})
export class SidebarLinkGrid {
  /**
   * Sidebar link grid title
   */
  @Prop() category: string;

  /**
   * Array of links to be displayed in grid
   */
  @Prop() icons: Array<Entry>;

  /**
   * Sets which icon is active
   */
  @Prop() activeIcon: string;

  private getIcon(icon) {
    return <img src={getFacadeUrl() + '/menuAssets/' + icon.icon._id} alt=""></img>;
  }

  render() {
    return (
      <Host>
        <div id="title-container">
          <sy-text class="title" type="small">
            {this.category}
          </sy-text>
        </div>
        <sy-grid type="grid" cols="3" gap="16px">
          {this.icons?.map((icon) => {
            return (
              <sy-cell key={icon.title}>
                <a
                  target="_self"
                  class={{
                    icon: true,
                    active: icon.title === this.activeIcon,
                  }}
                  href={icon.href}
                >
                  <div
                    class={{
                      icon: true,
                      active: icon.title === this.activeIcon,
                    }}
                  >
                    {this.getIcon(icon)}
                  </div>
                </a>
                <a target="_self" class="name" href={icon.href}>
                  <sy-text type="small">{icon.title}</sy-text>
                </a>
              </sy-cell>
            );
          })}
        </sy-grid>
      </Host>
    );
  }
}
